import React, { useState } from 'react';

// Talking points for call tasks. Each entry matches tasks by name. A task with no entry here shows its own description instead.
const SCRIPTS = [
  [/Setup\/Removal of Utilities/i, [
    'Ask which providers they plan to use for electric, water, gas if applicable, internet, and trash.',
    'Suggest scheduling service to start on the closing date, and ending the seller\'s service that same day.',
    'Remind them to keep the power on through the final walk-through.',
    'Ask whether they need help finding providers in the area. Call or text 239-488-5900 if they have questions.',
  ]],
  [/Keys and Closing Day Access/i, [
    'Confirm how the keys will be handed over and where they will be left.',
    'Ask whether they need any access arrangements on closing day.',
    'Confirm the best call or text number for closing day.',
  ]],
  [/Confirm Closing Date\/Time/i, [
    'Confirm the closing date and time, and where it will take place.',
    'Ask what they need to bring, and remind them to get wire instructions only from the title company.',
    'Confirm who will attend and how they want updates.',
  ]],
  [/Schedule Partial Staging Visit/i, [
    'Introduce yourself and say you are excited to start on their listing.',
    'Ask if it is okay for you to come over and bring some staging items before the photo shoot.',
    'Ask which day and time works best, and whether anyone else needs to be there.',
    'Ask about any access details, alarm codes, or pets you should know about.',
  ]],
  [/Schedule Photography|Confirm Photography/i, [
    'Let them know the photographer will be coming on the scheduled date.',
    'Ask about any access details, pets, or items they want moved before the shoot.',
    'Confirm the best number to reach them on the day of the shoot.',
  ]],
];

export const talkingPointsFor = (task) => {
  const name = task?.name || task?.title || '';
  const hit = SCRIPTS.find(([pattern]) => pattern.test(name));
  if (hit) return hit[1];
  return task?.description ? [task.description] : [];
};

const btn = { padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, border: '1px solid #D5D9E0', background: '#FFFFFF', color: '#8C6D1F', cursor: 'pointer' };

// "Talking points" button beside a Call button. Opens a short script for the call.
export default function CallTalkingPoints({ task }) {
  const [open, setOpen] = useState(false);
  const points = talkingPointsFor(task);
  if (points.length === 0) return null;
  return (
    <span style={{ display: 'inline-block', marginLeft: 8, verticalAlign: 'middle' }}>
      <button type="button" onClick={() => setOpen(!open)} style={btn}>{open ? 'Hide talking points' : 'Talking points'}</button>
      {open && (
        <div role="dialog" aria-label="Talking points" style={{ marginTop: 8, padding: 12, border: '1px solid #D4AF37', borderRadius: 8, background: '#FFFDF5', maxWidth: 420, boxSizing: 'border-box' }}>
          <div style={{ fontSize: 12, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#8C6D1F', fontWeight: 700, marginBottom: 6 }}>Talking points</div>
          {points.map((p, i) => (
            <p key={i} style={{ margin: '0 0 6px', fontSize: 14, color: '#1a1a1a', lineHeight: 1.5 }}>{i + 1}. {p}</p>
          ))}
        </div>
      )}
    </span>
  );
}
